export const radioButtonPreset = {
  radiobutton: {
    root: {
      borderColor: 'var(--neutral--30)',
      hoverBorderColor: 'var(--brand--50)',
      focusBorderColor: 'var(--brand--50)',
      checkedBackground: 'var(--brand--5)',
      checkedHoverBackground: 'var(--brand--5)',
      checkedBorderColor: 'var(--brand--50)',
      checkedHoverBorderColor: 'var(--brand--50)',
      checkedFocusBorderColor: 'var(--brand--50)',
      focusRing: {
        width: '3px',
        color: 'rgba(21, 93, 252, 0.12)',
        offset: '0rem',
        style: 'solid',
      },
    },
    icon: {
      size: '0.5rem',
      checkedColor: 'var(--brand--50)',
      checkedHoverColor: 'var(--brand--60)',
    },
  },
};
